import React, { useState } from 'react';
import FDA from '../assets/img/clients/FDA copy.png';
import alcoa from '../assets/img/clients/ALCOA++.png';
import cila from '../assets/img/clients/cila_2.png';
import eu from '../assets/img/clients/eu11.png';
import gxp from '../assets/img/clients/gxp.png';
import hippa from '../assets/img/clients/hippa.png';
import iso from '../assets/img/clients/iso.png';
import ispe from '../assets/img/clients/ispe.png';
import '../assets/css/circleAnimation.css';

const items = [
    {
        title: 'LOREM IPSUM',
        description: '',
        icon: FDA,
        color: '#2c3e50',
    },
    {
        title: 'ADIPISCING',
        description: '',
        icon: alcoa,
        color: '#f39c12',
    },
    {
        title: 'DOLOR SIT AMET',
        description: '',
        icon: cila,
        color: '#27ae60',
    },
    {
        title: 'CONSECTETUR',
        description: '',
        icon: eu,
        color: '#16e195',
    },
    {
        title: 'EXERCITATION',
        description: '',
        icon: gxp,
        color: '#2980b9',
    },
    {
        title: 'INFOGRAPHIC',
        description: '',
        icon: hippa,
        color: '#8e44ad',
    },
    {
        title: 'INFOGRAPHIC',
        description: '',
        icon: iso,
        color: '#e74c3c',
    },
    {
        title: 'INFOGRAPHIC',
        description: '',
        icon: ispe,
        color: '#d35400',
    },
];

const ComplianceStandards = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const [animatingDotIndex, setAnimatingDotIndex] = useState(null);
    
    const outerRadius = 180;
    const strokeWidth = 30;
    const centerX = 250;
    const centerY = 250;
    const angleStep = (2 * Math.PI) / items.length;

    const handleDotAnimationEnd = (index) => {
        setActiveIndex(index);
        setAnimatingDotIndex(null);
        
        setTimeout(() => {
            setActiveIndex(null);
        }, 1000);
    };

    const handleCircleHover = (index) => {
        setAnimatingDotIndex(index);
    };

    return (
        <div className="portifoliobody" style={{background:'#f0f0f0'}}>
            <main id="main">
                <section>
                    <div className="sf-title compliance-title">Our Commitment to Quality, Compliance, and Industry Best Practices</div>
                    <div className="infographic-container" data-aos="fade-up" data-aos-delay="100">
                        <svg className='circle-svg' viewBox="0 0 500 500">
                            {/* Outer ring */}
                            <circle
                                cx={centerX}
                                cy={centerY}
                                r={outerRadius - strokeWidth / 2}
                                fill="none"
                                stroke="#ddd"
                                strokeWidth={strokeWidth}
                            />

                            <defs>
                                <mask id="ringMask">
                                <circle
                                    cx={centerX}
                                    cy={centerY}
                                    r={outerRadius}
                                    fill="white"
                                />
                                <circle
                                    cx={centerX}
                                    cy={centerY}
                                    r={outerRadius - strokeWidth}
                                    fill="black"
                                />
                                </mask>
                            </defs>
                            <g mask="url(#ringMask)">
                                <g
                                className="animate-spin-slow"
                                style={{
                                    transformOrigin: `${centerX}px ${centerY}px`,
                                    animation: 'spin 30s linear infinite',
                                }}
                                >
                                {/* Draw the 8 segment divider lines */}
                                {Array.from({ length: 8 }).map((_, i) => {
                                    const angle = i * angleStep;
                                    const x1 = centerX + (outerRadius - strokeWidth) * Math.cos(angle);
                                    const y1 = centerY + (outerRadius - strokeWidth) * Math.sin(angle);
                                    const x2 = centerX + outerRadius * Math.cos(angle);
                                    const y2 = centerY + outerRadius * Math.sin(angle);

                                    return (
                                    <line
                                        key={i}
                                        x1={x1}
                                        y1={y1}
                                        x2={x2}
                                        y2={y2}
                                        stroke="#fff"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                    />
                                    );
                                })}
                                </g>
                            </g>

                            {items.map((item, i) => {
                                const angle = i * angleStep - Math.PI / 2;
                                const circleRadius = outerRadius - strokeWidth / 2;
                                const smallCircleX = centerX + circleRadius * Math.cos(angle);
                                const smallCircleY = centerY + circleRadius * Math.sin(angle);
                                const lineX = centerX + (circleRadius + 70) * Math.cos(angle);
                                const lineY = centerY + (circleRadius + 70) * Math.sin(angle);

                                return (
                                    <g key={i} className={`circle-group circle-group-${i}`}>
                                        <line
                                            x1={smallCircleX}
                                            y1={smallCircleY}
                                            x2={lineX}
                                            y2={lineY}
                                            stroke={item.color}
                                            strokeWidth="2"
                                            className='circle-line'
                                        />
                                        <circle
                                            cx={smallCircleX}
                                            cy={smallCircleY}
                                            r="10"
                                            fill="#fff"
                                            stroke={item.color}
                                            strokeWidth="3"
                                            className='hover-circle'
                                            onMouseEnter={() => handleCircleHover(i)}
                                        />
                                        {/* traveling dot */}
                                        <circle
                                            cx={smallCircleX}
                                            cy={smallCircleY}
                                            r="3"
                                            fill="#fff"
                                            stroke={item.color}
                                            strokeWidth="2"
                                            className={`traveling-dot traveling-dot-${i} ${animatingDotIndex === i ? 'animate-dot' : ''}`}
                                            style={{
                                                opacity: animatingDotIndex === i ? 1 : 0,
                                                '--start-x': `${smallCircleX}px`,
                                                '--start-y': `${smallCircleY}px`,
                                                '--end-x': `${lineX}px`,
                                                '--end-y': `${lineY}px`
                                            }}
                                            onAnimationEnd={() => handleDotAnimationEnd(i)}
                                        />
                                    </g>
                                );
                            })}

                            {/* Inner circle */}
                            <circle
                                cx={centerX}
                                cy={centerY}
                                r="150"
                                fill="#fff"
                                stroke="#ccc"
                                strokeWidth="2"
                            />
                            {/* <text
                                x={centerX}
                                y={centerY - 10}
                                textAnchor="middle"
                                fontSize="18"
                                fontWeight="bold"
                            >
                                Lab Iconics
                            </text>
                            <text x={centerX} y={centerY + 15} textAnchor="middle" fontSize="12">
                                Solutions
                            </text> */}
                        </svg>
                        <StaticLogo />

                        <div className="labels-div">
                            {items.map((item, i) => (
                                <div
                                    key={i}
                                    className={`label-div label-div-${i} ${activeIndex === i ? 'active-label' : ''}`}
                                    style={{ 
                                        borderColor: item.color,
                                        transform: activeIndex === i ? 
                                            (i === 0 || i === 4 ? 'scale(1.2) translateX(-40%)' : 'scale(1.2)') : 
                                            (i === 0 || i === 4 ? 'translateX(-50%)' : 'scale(1)'),
                                        zIndex: activeIndex === i ? 10 : 2,
                                        boxShadow: activeIndex === i ? '0 4px 10px rgba(0, 0, 0, 0.2)' : '0 2px 5px rgba(0, 0, 0, 0.1)',
                                        transition: 'transform 0.1s ease, box-shadow 0.1s ease'
                                    }}
                                >
                                    <div className="icon-label-div">
                                        <img src={item.icon} alt="" style={{height: '50px'}}/>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className='comp-context' data-aos="fade-up" data-aos-delay="100">
                        <div className='comp-text'>
                            At Lab Iconics, we are dedicated to delivering software solutions that align with global standards, regulatory requirements, and best practices for the life sciences and laboratory industries. Our LIMS, ELN, QMS, and DMS platforms are designed to meet the rigorous needs of regulated environments, ensuring data integrity, operational transparency, and compliance across the board.
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
};

const StaticLogo = () => {
  return (
    <div className="logo-container">
        <div className="logo-preload">
            <div className="logo-it logo-it-1"></div>
            <div className="logo-it logo-it-2"></div>
            <div className="logo-it logo-it-3"></div>
            <div className="logo-it logo-it-4"></div>
            <div className="logo-it logo-it-5"></div>
        </div>
    </div>
  );
};

export default ComplianceStandards;
